import { Box, IconButton, Typography } from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import Avatar from "@mui/material/Avatar";
import { toAbsoluteUrl } from "src/shared/setup/toAbsoluteUrl";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { getLinkWhatApp } from "src/Pages/components/CardPlans/CardPlans";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";

interface LineTempDescriptionsProps {
  trialDays: number;
  reminderDate: string;
  billingDate: string;
}

export const LineTempDescriptions = ({
  trialDays,
  reminderDate,
  billingDate,
}: LineTempDescriptionsProps) => {
  const { userPerfil } = useAuthContext();

  return (
    <Box sx={{ position: "relative", maxWidth: 350 }}>
      <Box
        sx={{
          position: "absolute",
          left: "calc(19px)",
          top: "40px",
          bottom: "calc(52% - 0px)",
          width: "2px",
          bgcolor: "#e0e0e0",
          zIndex: 1,
        }}
      />

      {/* Trial Start Info */}
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          mb: 4,
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: "#e6f5ea",
            borderRadius: "50%",
            p: "6px",
            display: "inline-flex",
            mr: 2,
            border: "2px solid white",
          }}
        >
          <CardGiftcardIcon sx={{ color: "#34a853" }} />
        </Box>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Hoje! Teste gratuito de {trialDays} dias. Cancele quando quiser.
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Comece o seu teste gratuito do Correctors e aproveite nossos
            recursos mais populares.
          </Typography>
        </Box>
      </Box>

      {/* Reminder Info */}
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          mb: 5,
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: "#e6e6f5",
            borderRadius: "50%",
            p: "6px",
            display: "inline-flex",
            mr: 2,
            border: "2px solid white",
          }}
        >
          <AppShortcutIcon sx={{ color: "#410798" }} />
        </Box>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {reminderDate}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Utilize o Correctors, e seja um Corretor de sucesso.
          </Typography>
        </Box>
      </Box>

      {/* Billing Start Info */}
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          mb: 4,
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: "#fff8e1",
            borderRadius: "50%",
            p: "6px",
            display: "inline-flex",
            mr: 2,
            border: "2px solid white",
          }}
        >
          <EventAvailableIcon sx={{ color: "#f9a825" }} />
        </Box>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {billingDate}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Caso você não tenha cancelado sua assinatura durante o período de
            teste, ela será ativada.
          </Typography>
        </Box>
      </Box>

      {/* Testimonial */}
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          border: "1px solid #dedede",
          borderRadius: "8px",
          p: 2,
          mb: 3,
        }}
      >
        <Avatar
          src={toAbsoluteUrl("/media/avatars/300-3.jpg")}
          sx={{ width: 35, height: 35, mr: 2, bgcolor: "#d0d0d0" }}
        />
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            Roberto Alves
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontStyle: "italic",
              color: "text.secondary",
              fontSize: "13px",
            }}
          >
            &quot;Sou muito fã do Corretors, pois ele nos dá a possibilidade de
            controlar contratos e disparar mensagem em massa de uma forma muito
            simples e por um valor super acessível.&quot;
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          padding: "0 12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography sx={{ fontSize: "12px", mr: 3 }}>
          Fale conosco e tire suas dúvidas
        </Typography>

        <IconButton
          href={getLinkWhatApp(
            "5511984939024",
            `Olá, me chamo ${userPerfil?.name}, tenho uma dúvida: `
          )}
          target="_blank"
          sx={{
            background: "#72f76962",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          <WhatsAppIcon color="success" sx={{ color: "#43d400e9" }} />
        </IconButton>
      </Box>
    </Box>
  );
};
